import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'settings-status',
  template: `
  <div class="settings-request-details__container__body__status lx-body">
    <span class="progressStatus {{statusCss}}"></span>
    {{status}}
  </div>`,
  styleUrls: ['./settings-status.component.scss']
})
export class SettingsStatusComponent implements ICellRendererAngularComp {

  constructor() { }

  status: string;
  statusCss: string;
  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.status = this.getStatusAndCss(params.data.status);
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.status = params.data.status;
    return true;
  }

  private getStatusAndCss(status: string): string {
    switch (status) {
      case 'Awaiting Approval':
        this.statusCss = 'awaiting-approval';
        return 'Awaiting Approval'
      case 'Completed':
        this.statusCss = 'completed'
        return 'Completed'
      case 'Approved':
        this.statusCss = 'approved'
        return 'Approved'
      case 'Rejected':
        this.statusCss = 'rejected'
        return 'Rejected'
      case 'Error':
        this.statusCss = 'error'
        return 'Error'
      case 'Failed':
        this.statusCss = 'failed'
        return 'Failed'
      default:
        return undefined;
    }
  }
}

